import React, { useEffect, useState } from 'react'
import { TextField, MenuItem } from '@mui/material'
import { useSuppliersOrigin } from '../../hooks/useSuppliersOrigin'
import { SupplierOrigin } from '../../interfaces/Supplier/Supplier'

interface SuppliersOriginDDLProps {
  onChange: any
  value: any
  type?: 'outlined' | 'filled' | 'standard' | undefined
  fullWidth?: boolean
  valueKey?: 'id' | 'supplierOriginName'
  required?: boolean
  disabled?: boolean
  size?: 'small' | 'medium' | undefined
  supplierId?: number
}

export const SupplierOriginDDL: React.FC<SuppliersOriginDDLProps> = ({
  onChange,
  value,
  type,
  fullWidth = false,
  valueKey = 'id',
  required = false,
  disabled = false,
  size,
  supplierId
}) => {
  const [hasError, setHasError] = useState<boolean>(false)

  const {
    suppliersOriginState: { suppliersOrigin },
    getSuppliersOrigin
  } = useSuppliersOrigin()

  useEffect(() => {
    if (suppliersOrigin?.length === 0) {
      getSuppliersOrigin()
    }
  }, [])

  useEffect(() => {
    // Validar si es obligatorio y si se ha seleccionado alguna opción
    if (required && value < 1) {
      setHasError(true)
    } else {
      setHasError(false)
    }
  }, [value, required])

  const arrTypePositions =
    suppliersOrigin !== undefined
      ? suppliersOrigin
          .filter(
            (item: SupplierOrigin) =>
              item.active && (!supplierId || item.supplierId === supplierId)
          )
          .map((option: SupplierOrigin) => (
            <MenuItem key={option[valueKey]} value={option[valueKey]}>
              {option.supplierOriginName}
            </MenuItem>
          ))
      : []

  return (
    <TextField
      variant={type}
      id='supplierOriginId'
      name='supplierOriginId'
      select
      value={value}
      onChange={onChange}
      fullWidth={fullWidth}
      disabled={disabled}
      size={size}
      error={hasError}
      helperText={hasError ? 'Seleccionar Origen de Proveedor' : undefined}
    >
      <MenuItem key={0} value={0}>
        {'Seleccione Origen de Proveedor ...'}
      </MenuItem>
      {arrTypePositions}
    </TextField>
  )
}
